import { ManagerResult } from '..';

export class ManagerSearch {
  constructor(public searchFilter: string, public managers: ManagerResult[]) {}
}
